<template>
  <ValidationObserver ref="validator">
    <AddressManualForm
      ref="addressManualForm"
      :addressForm="addressForm"
      @openInputFindProperty="openInputFindProperty"
    >
      <template #saveButton>
        <div>
          <v-btn
            color="#106175"
            depressed
            large
            rounded
            class="find-property-details font-20 font-weight-bold white--text"
            @click="onSubmit"
            aria-label="Save Address"
            >Save Address</v-btn
          >
        </div>
      </template>
    </AddressManualForm>
  </ValidationObserver>
</template>

<script>
import AddressManualForm from "@/components/AddressFinder/AddressManualForm.vue";
import { ADDRESS_FINDER_ANSWER_MAP as DATA_UIID } from "@/constants/form.constants";
import * as LABEL_CONSTANTS from "@/constants/label.constants";
import * as ERROR_MSG_CONSTANTS from "@/constants/message.constants";
import {
  ALPHANUMERIC_AND_SPECIAL_CHARS_PATTERN,
  POST_CODE as POST_CODE_PATTERN,
} from "@/constants/regex-patterns.constants";
import { QUESTIONS_MODULE } from "@/store/types/module-types";
import { ValidationObserver } from "vee-validate";
import { mapGetters, mapState } from "vuex";
import { scrollToFirstErrorInput } from "@/common/utils";

export default {
  name: "AddressFinderManuallyForm",
  props: {
    addressForm: {
      type: Object,
      required: true,
    },
  },
  components: {
    AddressManualForm,
    ValidationObserver,
  },
  data() {
    return {
      POST_CODE_PATTERN,
      ALPHANUMERIC_AND_SPECIAL_CHARS_PATTERN,
      LABEL_CONSTANTS,
      ERROR_MSG_CONSTANTS,
      DATA_UIID,
    };
  },
  computed: {
    ...mapState(QUESTIONS_MODULE, ["form"]),
    ...mapGetters(QUESTIONS_MODULE, ["propertyDataRequiresEdit"]),
    userMustFill() {
      // Shows the alert message if LN lookup failed
      return (
        this.form.propertyDetailsFormVisibility &&
        this.propertyDataRequiresEdit &&
        this.form.isLNErrorMessageEnabled
      );
    },
  },
  methods: {
    async onSubmit() {
      if (await this.$refs.validator.validate()) {
        this.$emit("saveManual", {
          postCode: this.addressForm.postCode.Value,
          street: this.addressForm.street.Value,
          district: this.addressForm.district.Value,
          town: this.addressForm.town.Value,
          county: this.addressForm.county.Value,
        });
      } else {
        setTimeout(() => {
          scrollToFirstErrorInput(this.$refs.addressManualForm.$children[0]);
        }, 0);
      }
    },
    openInputFindProperty() {
      this.$emit("openInputFindProperty");
    },
  },
};
</script>
<style lang="scss" scoped>
.find-property-details {
  width: 324px !important;
  height: 60px !important;
  border-radius: 54px;
  margin-top: -10px;
}
@media screen and (max-width: ($grid-breakpoints-lg - 1)) {
  .find-property-details {
    width: 100% !important;
    margin-top: 6px;
  }
}
</style>
